export default "__VITE_ASSET__C10tm5Ew__"